import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from '@services/breadcrumb/breadcrumb.service';
import {PagesHelperService} from '@services/pages/pages-helper.service';
import {MenuItem} from '@models/sidebar/menu-item';
import {ActivatedRoute} from '@angular/router';
import {PageGlobalParameters} from '@models/pages/page-global-parameters';
import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {FormPage, InputField} from '@models/sidebar/response/form-page';
import {FormPageService} from '@services/left-menu/page/form-page/form-page.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationService} from '@services/notification/notification.service';
import {User} from '@models/user/user';
import {Role} from '@models/user/role';
import { HttpResponse } from '@angular/common/http';
import {FirebaseAuthenticationService} from '@services/firebase/auth/firebase-authentication.service';

@Component({
    selector: 'scitis-form-page-container',
    templateUrl: './form-page-container.component.html',
    styleUrls: ['./form-page-container.component.scss'],
    standalone: false
})
export class FormPageContainerComponent implements OnInit {

  public pageGlobalParameters: PageGlobalParameters = new PageGlobalParameters();
  public breadcrumbRoutes: MenuItem[] = [];
  public formPageConfiguration = new FormPage();
  public isTechAdminOrHigher: boolean = false;

  private CURRENT_PAGE_NAME: string = 'FormPage';

  constructor(private activatedRoute: ActivatedRoute,
              private firebaseAuthenticationService: FirebaseAuthenticationService,
              private pagesHelperService: PagesHelperService,
              private loadingIndicator: LoadingIndicatorService,
              private breadcrumbService: BreadcrumbService,
              private formPageService: FormPageService,
              private translateService: TranslateService,
              private notificationService: NotificationService) {
  }

  private static orderInputFields(inputFields: InputField[]) {
    if (!inputFields || inputFields.length <= 0) {
      return;
    }
    inputFields.sort((function (a, b) {
      return a.index - b.index;
    }));
  }

  ngOnInit(): void {
    this.loadingIndicator.show();
    this.pageGlobalParameters = this.pagesHelperService.getPageDetailsFromUrl(this.activatedRoute.snapshot.paramMap);
    this.generateRoutes(this.pageGlobalParameters.associatedMenuItem);
    this.getFormPageConfiguration();
    this.firebaseAuthenticationService.getLoggedUserDetails().subscribe((user: User) => {
      if (user.parentId) {
        const userRole = new Role(user);
        this.isTechAdminOrHigher = userRole.isTechAdminRole || userRole.isSuperAdminRole;
      }
    }, (error: HttpResponse<any>) => {
      console.error(`${this.CURRENT_PAGE_NAME}. Error getting current user details.`, JSON.stringify(error));
    });
  }

  onSaveFormConfiguration(formPage: FormPage) {
    this.loadingIndicator.show();
    this.formPageService.save(this.pageGlobalParameters.machineId, formPage).subscribe((savedPage: FormPage) => {
      const successMessage = this.translateService.instant('Saved form page configuration');
      this.formPageConfiguration = Object.assign(new FormPage(), savedPage);
      this.notificationService.success(successMessage, this.CURRENT_PAGE_NAME, true);
      this.loadingIndicator.hide();
    }, (error) => {
      const errorMessage = this.translateService.instant('There was an error saving the form page');
      this.notificationService.error(errorMessage, error, this.CURRENT_PAGE_NAME, true);
      this.loadingIndicator.hide();
    });
  }

  private generateRoutes(menuItem: MenuItem) {
    this.breadcrumbRoutes = this.breadcrumbService.generateRoutes(menuItem);
  }

  private getFormPageConfiguration() {
    this.formPageService.getFormPage(this.pageGlobalParameters.machineId, this.pageGlobalParameters.pageId).subscribe((formPage: FormPage) => {
      this.formPageConfiguration = formPage;
      FormPageContainerComponent.orderInputFields(this.formPageConfiguration.inputFields);
      this.loadingIndicator.hide();
    }, (error) => {
      console.log(error);
      this.loadingIndicator.hide();
    });
  }
}
